<template>
  <div>
    <div class="head-title">客户群活码</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            1、在客户群活码功能中可添加多个群聊的二维码或是群活码，添加完成后会生成一个渠道群活码。<a
              class="help-link"
              href="https://www.weijub.com/index/index/news_detail?id=120"
              target="_blank"
              rel="noopener noreferrer"
              >使用教程</a
            >
          </p>
          <p>
            2、可查看每个群活码的基本信息以及相应的客户群活码明细，包括活码图片、每个群活码的客户数等内容。
          </p>
          <p>
            3、生成的客户群活码可通过下载二维码和链接的这两种方式进行推广和宣传。
          </p>
          <p>
            4、客户群活码功能将完全打破企业微信官方群活码只能选择5个群聊的局限，只要企业微信群活码的数量足够多，可在此添加多个群活码，当第一个群二维码或群活码人数到达上限后系统将自动推送第二个群二维码或群活码，让您的推广营销更便捷。
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="mMain">
      <nav class="navbar">
        <div class="nav-l">
          <el-button type="primary" icon="el-icon-plus" @click="onAdd"
            >新建客户群活码</el-button
          >
          <el-button
            style="margin-left: 2.4rem"

            icon="el-icon-delete"
            @click="onDels"
            >批量删除</el-button
          >
        </div>
        <div class="nav-r">
          <el-date-picker
            v-model="time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getData()"
            style="width: 50.0rem;"
          >
          </el-date-picker>
          <el-input
            clearable
            style="width: 35.0rem;margin-left:2.0rem; "
            placeholder="请输入活码名称搜索"
            prefix-icon="el-icon-search"
            v-model="q"
            @change="getData()"
          >
          <el-button slot="append" type="primary" @click="getData()"
            >查询</el-button
          >
          </el-input>

        </div>
      </nav>
      <div class="container">
        <el-table
          :data="list"
          v-loading="tableLoading"
          style="margin-top: 2.0rem"
          border

          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="name" label="群活码名称"> </el-table-column>
          <el-table-column prop="code_image" label="群活码图片">
            <template slot-scope="scope">
              <el-image
                style="width: 7.0rem; height: 7.0rem"
                :src="scope.row.code_image"
                :preview-src-list="[scope.row.code_image]"
                fit="scale-down"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="gruop_count" label="上传群数量">
          </el-table-column>
          <el-table-column prop="author" label="创建人"></el-table-column>
          <el-table-column prop="createtime" label="创建时间">
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="300">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="onDetail(scope.row)"
              >
                查看
              </el-button>
              <el-button type="text" size="mini">
                <a
                  :href="`https://api.weijub.com/crm/ActiveCode/getImages?url=${scope.row.code_image}&usertoken=${tooken.usertoken}`"
                  style="color: #317AF8"
                  :download="`${scope.row.user}的渠道活码`"
                  >下载</a
                >
              </el-button>
              <el-button @click="onDel(scope.row)" size="mini" type="text"  style="color:#f00000 !important">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paging">
          <pagination
            :total="total"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            :page-sizes="[10,20,50,100]"
            @pagination="getData"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "customerCode",
  data() {
    return {
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      q: "",
      time: "",
      star_time: "",
      end_time: "",
      multipleSelection: [],
      tableLoading: true
    };
  },

  components: {},

  computed: {},

  mounted() {
    this.getData();
  },

  methods: {
    onAdd() {
      this.$router.push({
        name: "customerCodeAdd",
      });
    },
    async getData() {
      if (Array.isArray(this.time)) {
        this.star_time = new Date(this.time[0]).getTime();
        this.end_time = new Date(this.time[1]).getTime();
        this.star_time = this.star_time / 1000;
        this.end_time = this.end_time / 1000;
      } else {
        this.star_time = "";
        this.end_time = "";
      }
      const { data: res } = await this.axios({
        url: "/crm/GroupLiveCodeTwo/LiveCodesList",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          name: this.q,
          star_time: this.star_time,
          end_time: this.end_time,
          page: this.listQuery.page,
          number_page:this.listQuery.limit,
        }),
      });
      if (res.code == 1) {
        this.tableLoading = false;
        this.list = res.data.data;
        this.total = res.data.total;
      }
    },
    async onDetail(row) {
      this.$router.push({
        name: "customerCodeDetail",
        query: {
          id: row.id,
        },
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onDels() {
      if (this.multipleSelection.length > 0) {
        this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            const ids = this.multipleSelection.map((i) => i.id);
            this.del(String(ids));
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message("请选择您要删除的任务");
      }
    },
    onDel(row) {
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.del(row.id);
        })
        .catch(() => {
          this.$message({
            message: "已取消删除",
            type: "info",
          });
        });
    },
    async del(id) {
      const { data: res } = await this.axios({
        url: "/crm/GroupLiveCodeTwo/del",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          id,
        }),
      });
      if (res.code == 1) {
        this.$message({
          message: res.msg,
          type: "success",
        });
        this.getData();
      } else if (res.code == 0) {
        this.$message.error(res.msg);
      }
    },
  },
};
</script>
<style  scoped>
.el-button--text{padding-left:.0rem !important;}
</style>
